import { AnyAction } from 'redux';
import { ReduxAction } from '../../enums/const-enums';

export const updateChallengeData = (
  challengeData: AppModel.ChallengeData,
): AnyAction => {
  return {
    type: ReduxAction.CHALLENGE_DATA_UPDATE,
    payload: challengeData,
  };
};

export const clearChallengeData = (): AnyAction => {
  return {
    type: ReduxAction.CHALLENGE_DATA_CLEAR,
  };
};
